/**
 * Spinner — l'anneau qui tourne (lot 4 du catalogue, 01-11-2026) : petit, calme, gris. À la place
 * des cent trente `animate-spin` du cockpit. `ton="marque"` pour un chargement de premier plan,
 * `"courant"` pour prendre l'encre de ce qui l'entoure (le Button `enCours` s'en sert).
 * Sous « réduire les animations », l'anneau s'arrête mais se lit toujours.
 *
 *   <Spinner />                      18 px, « Chargement » pour les lecteurs d'écran
 *   <Spinner taille="lg" ton="marque" ariaLabel="Envoi en cours" />
 *   <Spinner decoratif />            sans rôle — quand le parent dit déjà qu'il charge
 */
import { cn } from "./utils";
import "./prevenir.css";

export interface SpinnerProps {
  /** `sm` 14 px · `md` 18 px (défaut) · `lg` 28 px. */
  taille?: "sm" | "md" | "lg";
  ton?: "gris" | "marque" | "courant";
  /** Pour les lecteurs d'écran. Défaut « Chargement ». */
  ariaLabel?: string;
  /** Sans rôle ni étiquette : le parent porte déjà `aria-busy`. */
  decoratif?: boolean;
  className?: string;
}

export function Spinner({ taille = "md", ton = "gris", ariaLabel = "Chargement", decoratif = false, className }: SpinnerProps) {
  return (
    <span
      role={decoratif ? undefined : "status"}
      aria-label={decoratif ? undefined : ariaLabel}
      aria-hidden={decoratif || undefined}
      className={cn("pv-spinner pv-rond", className)}
      data-taille={taille}
      data-ton={ton === "gris" ? undefined : ton}
    />
  );
}
